const IMAGE_DATA_REGEX = /data:image\/.*;base64,(.*)/i;

/**
 * This class represents a BASE64 encoded image data string that the FileReader API
 * returns when loading an image as a data url
 */
export class Base64ImageData {
    public readonly data: string;

    constructor(imageDataUrl: string) {
        const match = IMAGE_DATA_REGEX.exec(imageDataUrl);
        if (!match) {
            throw new Error(
                'Could not create Base64 Image Data from Image Data Url because of incorrect format'
            );
        }
        this.data = match[1];
    }
}
